// src/utils/publicPaths.js

const RESERVED_ROOT_SLUGS = new Set([
  "login",
  "signup",
  "forgot-password",
  "reset-password",
  "profile",
  "user",
  "topic",
  "add-topic",
  "activity",
  "admin",
  "info",
  "api",
  "uploads",
  "share",
  "robots.txt",
  "sitemap-index.xml",
  "sitemaps",
]);

export function normalizePublicSlug(value = "") {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function isReservedRootSlug(value = "") {
  return RESERVED_ROOT_SLUGS.has(normalizePublicSlug(value));
}

export function getTopicPublicSlug(topic = null) {
  if (!topic || typeof topic !== "object") return "";
  return normalizePublicSlug(topic.word || topic.title || topic.name || "");
}

export function getProfilePublicSlug(user = null) {
  if (!user || typeof user !== "object") return "";
  return normalizePublicSlug(user.username || user.handle || user.name || "");
}

export function buildLegacyTopicPath(topicOrId) {
  const rawId =
    topicOrId && typeof topicOrId === "object" ? topicOrId.id : topicOrId;

  if (rawId === null || rawId === undefined || rawId === "") {
    return "/";
  }

  return `/topic/${encodeURIComponent(String(rawId))}`;
}

export function buildLegacyProfilePath(userOrId) {
  const rawId =
    userOrId && typeof userOrId === "object" ? userOrId.id : userOrId;

  if (rawId === null || rawId === undefined || rawId === "") {
    return "/profile";
  }

  return `/user/${encodeURIComponent(String(rawId))}`;
}

export function buildTopicPath(topicOrWord) {
  const raw =
    typeof topicOrWord === "string"
      ? topicOrWord
      : getTopicPublicSlug(topicOrWord);

  const slug = normalizePublicSlug(raw);

  if (!slug) {
    return typeof topicOrWord === "object"
      ? buildLegacyTopicPath(topicOrWord)
      : "/";
  }

  return `/${encodeURIComponent(slug)}`;
}

export function buildProfilePath(userOrName) {
  const raw =
    typeof userOrName === "string"
      ? userOrName
      : getProfilePublicSlug(userOrName);

  const slug = normalizePublicSlug(raw);

  if (!slug) {
    return typeof userOrName === "object"
      ? buildLegacyProfilePath(userOrName)
      : "/profile";
  }

  return `/${encodeURIComponent(slug)}`;
}